import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations, mapState } from 'vuex';
import loader from '../modals/loader';
import XLSX from 'xlsx';

export default {
    components: {
        loader: loader
    },
    data: function data() {
        return {
            logs: [{ name: 'Login/Logout', icon: ['fas', 'sign-in-alt'], color: { color: '#f7c644' } }, { name: 'Modificacion - usuario', icon: ['fas', 'user-edit'], color: { color: '#f7c644' } }, { name: 'Creación - usuario', icon: ['fas', 'users'], color: { color: '#f7c644' } }, { name: 'Activación/inactivación - usuarios', icon: ['fas', 'user-check'], color: { color: '#f7c644' } }, { name: 'Auditoría funcionalidad aplicación', icon: ['fas', 'clipboard-check'], color: { color: '#f7c644' } }, { name: 'Auditoría previsualizacion comisiones', icon: ['fas', 'tasks'], color: { color: '#f7c644' } }],
            selectedIndex: null,
            months: [],
            month: {},
            items: []
        };
    },
    created: function created() {
        var months = [{ mes: 'enero', num: '1' }, { mes: 'febrero', num: '2' }, { mes: 'marzo', num: '3' }, { mes: 'abril', num: '4' }, { mes: 'mayo', num: '5' }, { mes: 'junio', num: '6' }, { mes: 'julio', num: '7' }, { mes: 'agosto', num: '8' }, { mes: 'setiembre', num: '9' }, { mes: 'octubre', num: '10' }, { mes: 'noviembre', num: '11' }, { mes: 'diciembre', num: '12' }];
        var date = new Date();
        var month = date.getMonth();
        var year = date.getFullYear();

        // let month = 3;
        // let year = 2022;

        var getMonths = [];

        this.month = { name: months[month].mes + '-' + year, year: year, num: month + 1 };

        if (year === 2020) {
            for (var i = month; i >= 10; i--) {
                getMonths.push({
                    name: months[i].mes + '-' + year, year: year, num: months[i].num
                });
            }
        }
        if (year >= 2021) {
            if (month <= 5) {
                for (var _i = month; _i >= 0; _i--) {
                    if (_i > 0) {
                        getMonths.push({
                            name: months[_i].mes + '-' + year, year: year, num: months[_i].num
                        });
                    }
                    if (_i === 0) {
                        getMonths.push({
                            name: months[_i].mes + '-' + year, year: year, num: months[_i].num
                        });
                        month = 11;
                        year -= 1;
                        for (var j = month; j >= 10; j--) {
                            if (getMonths.length < 6) getMonths.push({
                                name: months[j].mes + '-' + year, year: year, num: months[j].num
                            });
                        }
                    }
                }
            } else {
                var limit = month - 6;
                for (var _i2 = month; _i2 > limit; _i2--) {
                    getMonths.push({
                        name: months[_i2].mes + '-' + year, year: year, num: months[_i2].num
                    });
                }
            }
        }
        this.months = getMonths.reverse();
    },

    computed: {},
    methods: {
        reportDownload: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(type) {
                var logType, date, res;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.$refs.loaderModal.showLoader();
                                _context.prev = 1;
                                logType = type;
                                date = this.month.num + '/' + this.month.year;

                                console.log("date -> ", date, type);
                                _context.next = 7;
                                return this.$store.dispatch("affiliations/form/getLogsType", { logType: logType, date: date });

                            case 7:
                                res = _context.sent;

                                this.items = res;
                                this.$refs.loaderModal.closeLoader();

                                if (this.items.length) this.download(logType, date);else this.$swal('Aviso', 'No existe registros para ese mes.', 'warning');
                                _context.next = 17;
                                break;

                            case 13:
                                _context.prev = 13;
                                _context.t0 = _context['catch'](1);

                                console.log(_context.t0);
                                this.$swal('Error', 'Error en el servicio. Vuelva a intentarlo mas tarde.', 'error');

                            case 17:
                                this.$refs.loaderModal.closeLoader();

                            case 18:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[1, 13]]);
            }));

            function reportDownload(_x) {
                return _ref.apply(this, arguments);
            }

            return reportDownload;
        }(),
        download: function download(type, date) {
            var data = XLSX.utils.json_to_sheet(this.items);
            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, data, 'Hoja 01');
            XLSX.writeFile(wb, this.generateFileName(type, date));
        },
        generateFileName: function generateFileName(type, date) {
            var nameFile = '';
            var index = type - 1;

            nameFile = 'Reporte_' + this.logs[index].name + '_' + date + '.xlsx';
            return nameFile;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stepper/report-choice.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stepper/report-choice.vue
// module chunks = 0 1 2 3